export interface Comic {
  id: string;
  name: string;
  author: string;
  category: string;
  status: string;
  chapters: string;
  rating: number;
  tags: string[];
  cover: string;
  intro: string;
  hot?: boolean;
  new?: boolean;
}

export const categories = [
  "全部",
  "热血少年",
  "玄幻仙侠",
  "都市生活",
  "悬疑推理",
  "恋爱言情",
  "科幻末世",
  "搞笑日常",
  "治愈暖心",
  "历史武侠",
  "体育竞技",
];

export const comics: Comic[] = [
  {
    id: "po-xiao-zhi-ren",
    name: "破晓之刃",
    author: "陈墨",
    category: "热血少年",
    status: "连载中",
    chapters: "856话",
    rating: 9.6,
    tags: ["少年热血", "战斗", "成长"],
    cover: "https://readdy.ai/api/search-image?query=anime%20comic%20book%20cover%20illustration%20of%20a%20determined%20young%20boy%20gripping%20a%20glowing%20sword%20against%20a%20dramatic%20sunrise%20sky%2C%20bold%20ink%20linework%2C%20vibrant%20warm%20orange%20and%20teal%20palette%2C%20poster%20style%2C%20portrait%20composition%2C%20clean%20minimal%20background&width=600&height=900&seq=manhua-poxiao&orientation=portrait",
    intro:
      "少年云澈背负灭门之仇踏上修行之路，在破晓的第一缕光中握起那把传说之刃。热血与羁绊交织的成长史诗，见证凡人如何一步步问鼎苍穹。",
    hot: true,
  },
  {
    id: "xian-men-wu-jian",
    name: "仙门无间",
    author: "洛青梧",
    category: "玄幻仙侠",
    status: "连载中",
    chapters: "998话",
    rating: 9.3,
    tags: ["修仙", "宗门", "爽文"],
    cover: "https://readdy.ai/api/search-image?query=chinese%20xianxia%20comic%20cover%20with%20a%20graceful%20sword%20cultivator%20in%20flowing%20white%20robes%20standing%20on%20misty%20mountains%2C%20ink%20wash%20style%2C%20warm%20gold%20and%20teal%20accents%2C%20portrait%20poster%20composition%2C%20clean%20background&width=600&height=900&seq=manhua-xianmen&orientation=portrait",
    intro:
      "一介凡体误入仙门，却发现自己身怀无间道体。步步惊心，处处杀机，看主角在尔虞我诈的仙门中如何逆天改命、笑傲九天。",
    hot: true,
  },
  {
    id: "cheng-duan-feng-bao",
    name: "灌篮风暴",
    author: "高原",
    category: "体育竞技",
    status: "连载中",
    chapters: "734话",
    rating: 9.2,
    tags: ["篮球", "热血", "青春"],
    cover: "https://readdy.ai/api/search-image?query=anime%20comic%20cover%20of%20a%20basketball%20player%20dunking%20mid-air%20in%20a%20packed%20gymnasium%2C%20dynamic%20motion%20lines%2C%20warm%20amber%20and%20coral%20lighting%2C%20vibrant%20poster%20style%2C%20portrait%20composition%2C%20clean%20background&width=600&height=900&seq=manhua-guanlan&orientation=portrait",
    intro:
      "从被嘲笑的门外汉到球场上的绝对核心，少年林昭用一记记暴扣回应所有质疑。汗水、热血与兄弟情，献给每一个热爱篮球的你。",
    hot: true,
  },
  {
    id: "zhi-yu-za-huo-pu",
    name: "治愈杂货铺",
    author: "苏念",
    category: "治愈暖心",
    status: "连载中",
    chapters: "189话",
    rating: 9.4,
    tags: ["治愈", "日常", "温馨"],
    cover: "https://readdy.ai/api/search-image?query=cozy%20manga%20cover%20of%20a%20small%20warm%20general%20store%20at%20sunset%20with%20soft%20glowing%20lanterns%20and%20a%20friendly%20shopkeeper%2C%20pastel%20warm%20palette%2C%20gentle%20linework%2C%20healing%20slice%20of%20life%20style%2C%20portrait%20poster%20composition%2C%20clean%20background&width=600&height=900&seq=manhua-zhiyu&orientation=portrait",
    intro:
      "深夜的城市一角，有一家只收烦恼不收钱的杂货铺。每个走进来的客人，都会带走一份重新出发的勇气。治愈系口碑之作。",
    hot: true,
  },
  {
    id: "mi-an-zhen-tan-she",
    name: "谜案侦探社",
    author: "顾北",
    category: "悬疑推理",
    status: "连载中",
    chapters: "415话",
    rating: 9.1,
    tags: ["推理", "悬疑", "烧脑"],
    cover: "https://readdy.ai/api/search-image?query=noir%20detective%20comic%20cover%20with%20a%20sleuth%20holding%20a%20magnifying%20glass%20under%20dramatic%20lamplight%2C%20mysterious%20shadows%2C%20warm%20brown%20and%20deep%20teal%20tones%2C%20portrait%20poster%20composition%2C%20clean%20background&width=600&height=900&seq=manhua-mian&orientation=portrait",
    intro:
      "五桩悬而未决的谜案，把毫无交集的陌生人聚到同一家侦探社。抽丝剥茧、层层反转，真相永远藏在最不起眼的细节里。",
    new: true,
  },
  {
    id: "xing-hai-ji-yuan",
    name: "星海纪元",
    author: "秦川",
    category: "科幻末世",
    status: "连载中",
    chapters: "512话",
    rating: 9.0,
    tags: ["科幻", "末世", "机甲"],
    cover: "https://readdy.ai/api/search-image?query=sci-fi%20mecha%20comic%20cover%20of%20a%20sleek%20giant%20robot%20rising%20from%20a%20ruined%20city%20under%20a%20teal%20nebula%20sky%2C%20glowing%20coral%20accent%20lights%2C%20epic%20scale%2C%20portrait%20poster%20composition%2C%20clean%20background&width=600&height=900&seq=manhua-xinghai&orientation=portrait",
    intro:
      "星际文明崩塌后的第两百年，人类在废墟中重启机甲计划。少年驾驶初代原型机，为守住的最后一盏灯火而战。",
    new: true,
  },
  {
    id: "ao-jiao-mao",
    name: "呆萌日常",
    author: "团团",
    category: "搞笑日常",
    status: "连载中",
    chapters: "388话",
    rating: 8.7,
    tags: ["搞笑", "萌宠", "减压"],
    cover: "https://readdy.ai/api/search-image?query=funny%20cute%20chibi%20comic%20cover%20of%20an%20expressive%20round%20cat%20and%20a%20clumsy%20roommate%20in%20chaos%2C%20bright%20cheerful%20warm%20palette%2C%20comic%20style%2C%20portrait%20poster%20composition%2C%20clean%20background&width=600&height=900&seq=manhua-doudou&orientation=portrait",
    intro:
      "一只会说话的傲娇猫 + 一个永远迷糊的室友，鸡飞狗跳又笑点密集的日常。每天三分钟，专治不开心。",
  },
  {
    id: "ning-meng-qing",
    name: "夏日的柠檬",
    author: "温晚",
    category: "恋爱言情",
    status: "连载中",
    chapters: "206话",
    rating: 8.8,
    tags: ["恋爱", "校园", "清新"],
    cover: "https://readdy.ai/api/search-image?query=romantic%20school%20comic%20cover%20of%20a%20boy%20and%20girl%20under%20a%20lemon%20tree%20on%20a%20summer%20afternoon%2C%20fresh%20yellow%20and%20warm%20cream%20palette%2C%20soft%20light%2C%20portrait%20poster%20composition%2C%20clean%20background&width=600&height=900&seq=manhua-xiari&orientation=portrait",
    intro:
      "转学第一天，她把柠檬汽水泼在了全校最冷的那朵高岭之花身上。一段酸酸甜甜、又带着柠檬清香的校园恋爱就此开始。",
  },
  {
    id: "jiang-hu-wang-shi",
    name: "江湖往事",
    author: "沈知白",
    category: "历史武侠",
    status: "已完结",
    chapters: "267话",
    rating: 8.6,
    tags: ["武侠", "江湖", "怀旧"],
    cover: "https://readdy.ai/api/search-image?query=ancient%20wuxia%20comic%20cover%20of%20a%20lone%20swordsman%20under%20a%20large%20moon%20beside%20an%20inn%20with%20warm%20lantern%20glow%2C%20ink%20style%2C%20amber%20and%20deep%20brown%20tones%2C%20portrait%20poster%20composition%2C%20clean%20background&width=600&height=900&seq=manhua-jianghu&orientation=portrait",
    intro:
      "一碗浊酒，一段旧事。老侠客在风雪客栈里，向少年讲起那些快意恩仇、又身不由己的江湖岁月。全集完结，可放心追完。",
  },
  {
    id: "ling-yi-dang-an-guan",
    name: "灵异档案馆",
    author: "江澈",
    category: "悬疑推理",
    status: "连载中",
    chapters: "301话",
    rating: 8.5,
    tags: ["灵异", "惊悚", "档案"],
    cover: "https://readdy.ai/api/search-image?query=supernatural%20horror%20comic%20cover%20of%20an%20old%20archive%20room%20with%20glowing%20files%20and%20shadowy%20figures%2C%20eerie%20warm%20and%20deep%20teal%20lighting%2C%20portrait%20poster%20composition%2C%20clean%20background&width=600&height=900&seq=manhua-lingyi&orientation=portrait",
    intro:
      "每一份尘封的档案背后，都藏着一段不为人知的故事。档案管理员阿澈以凡人之躯，一次次接近真相的边缘。",
  },
  {
    id: "du-shi-ye-xing",
    name: "都市夜行",
    author: "白慕",
    category: "都市生活",
    status: "连载中",
    chapters: "621话",
    rating: 8.9,
    tags: ["都市", "职场", "成长"],
    cover: "https://readdy.ai/api/search-image?query=urban%20drama%20comic%20cover%20of%20a%20young%20office%20worker%20walking%20through%20city%20night%20lights%20reflected%20on%20rain%20streets%2C%20cinematic%20warm%20and%20teal%20tones%2C%20portrait%20poster%20composition%2C%20clean%20background&width=600&height=900&seq=manhua-dushi&orientation=portrait",
    intro:
      "白天是格子间的普通职员，夜晚却游走在都市的另一面。一部关于理想、现实与选择的都市成长物语。",
  },
  {
    id: "cang-qiong-zhan-ji",
    name: "苍穹战记",
    author: "夜北",
    category: "玄幻仙侠",
    status: "连载中",
    chapters: "1120话",
    rating: 8.9,
    tags: ["玄幻", "神魔", "热血"],
    cover: "https://readdy.ai/api/search-image?query=epic%20fantasy%20comic%20cover%20of%20a%20warrior%20flying%20above%20clouds%20toward%20a%20giant%20ancient%20gate%20in%20the%20sky%2C%20majestic%20warm%20gold%20and%20teal%20palette%2C%20portrait%20poster%20composition%2C%20clean%20background&width=600&height=900&seq=manhua-cangqiong&orientation=portrait",
    intro:
      "苍穹之上，天门洞开。一个来自凡尘的少年，将在这里书写属于自己的战记。超长连载，量大管饱，追更不焦虑。",
  },
];

export interface RankingItem {
  rank: number;
  comicId: string;
  change: string;
  trend: "up" | "down" | "flat";
  weekly: string;
}

export const rankings: RankingItem[] = [
  { rank: 1, comicId: "po-xiao-zhi-ren", change: "+3", trend: "up", weekly: "12.6万" },
  { rank: 2, comicId: "xian-men-wu-jian", change: "持平", trend: "flat", weekly: "11.9万" },
  { rank: 3, comicId: "zhi-yu-za-huo-pu", change: "+1", trend: "up", weekly: "10.4万" },
  { rank: 4, comicId: "cheng-duan-feng-bao", change: "-2", trend: "down", weekly: "9.8万" },
  { rank: 5, comicId: "mi-an-zhen-tan-she", change: "+5", trend: "up", weekly: "8.7万" },
  { rank: 6, comicId: "xing-hai-ji-yuan", change: "持平", trend: "flat", weekly: "8.1万" },
  { rank: 7, comicId: "cang-qiong-zhan-ji", change: "+2", trend: "up", weekly: "7.6万" },
  { rank: 8, comicId: "du-shi-ye-xing", change: "-4", trend: "down", weekly: "7.2万" },
  { rank: 9, comicId: "ning-meng-qing", change: "+1", trend: "up", weekly: "6.9万" },
  { rank: 10, comicId: "ao-jiao-mao", change: "持平", trend: "flat", weekly: "6.4万" },
  { rank: 11, comicId: "jiang-hu-wang-shi", change: "-3", trend: "down", weekly: "5.8万" },
  { rank: 12, comicId: "ling-yi-dang-an-guan", change: "持平", trend: "flat", weekly: "5.3万" },
];

export interface Testimonial {
  name: string;
  avatar: string;
  role: string;
  text: string;
  stars: number;
}

export const testimonials: Testimonial[] = [
  {
    name: "追更的老K",
    avatar: "https://readdy.ai/api/search-image?query=flat%20illustration%20avatar%20of%20a%20friendly%20young%20man%20wearing%20headphones%2C%20warm%20orange%20tones%2C%20minimal%20circular%20portrait%2C%20clean%20background&width=300&height=300&seq=avatar-01&orientation=squarish",
    role: "追了五年连载的老读者",
    text: "订阅提醒特别准，更新一秒钟都不错过。离线缓存每天通勤路上看，真的是追更神器。",
    stars: 5,
  },
  {
    name: "柠檬味的风",
    avatar: "https://readdy.ai/api/search-image?query=flat%20illustration%20avatar%20of%20a%20young%20woman%20with%20short%20hair%20smiling%2C%20warm%20teal%20and%20amber%20tones%2C%20minimal%20circular%20portrait%2C%20clean%20background&width=300&height=300&seq=avatar-02&orientation=squarish",
    role: "恋爱番深度爱好者",
    text: "个性化推荐太懂我了，每周都能发现宝藏新番。历史记录同步也方便，换设备接着看。",
    stars: 5,
  },
  {
    name: "夜跑者阿南",
    avatar: "https://readdy.ai/api/search-image?query=flat%20illustration%20avatar%20of%20a%20young%20man%20in%20a%20hoodie%20with%20a%20backpack%2C%20warm%20neutral%20tones%2C%20minimal%20circular%20portrait%2C%20clean%20background&width=300&height=300&seq=avatar-03&orientation=squarish",
    role: "学生党 / 玄幻迷",
    text: "收藏夹分类整理特别方便，书架一眼清爽。页面不卡顿，翻页很跟手，体验是真的顺。",
    stars: 4,
  },
];

export const comicById = (id: string): Comic | undefined =>
  comics.find((c) => c.id === id);